import { ApiUrlConstants } from 'src/app/common/constants/api.constants';
import { catchError } from 'rxjs/internal/operators';
import { Observable } from 'rxjs/Observable';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./cache.service";
export class StorePortalService {
    constructor(httpClient, _cacheService) {
        this.httpClient = httpClient;
        this._cacheService = _cacheService;
    }
    /**
   * To get Store portal mappings by Id
   * @returns Observable
   */
    getStorePortals(storeId) {
        const getStorePortals = ApiUrlConstants.configurationApiUrl + 'stores/' + storeId + '/portals';
        return this.httpClient
            .get(decodeURIComponent(encodeURIComponent(getStorePortals)))
            .pipe(catchError(this.handleErrorObservable)).toPromise();
    }
    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    handleErrorObservable(error) {
        return Observable.throw(error);
    }
}
StorePortalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StorePortalService_Factory() { return new StorePortalService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.CacheService)); }, token: StorePortalService, providedIn: "root" });
